// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"afee65c7","242":"749658de","453":"4e831c6d","751":"970293e4"}[chunkId] + ".chunk.js";
};